import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import UserContext from "src/provider/state-manager/userProvider"
import { AppText, Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { AccountDeletionContainer } from "src/component"

export const AcctDeleteOtherReasons: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user, setUserProperty} = useContext(UserContext)
    const [reason, setReason] = useState('')

    const acctDeletionFlowType = utility.getAccountDeletionFlowType()
    
    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!reason) return notifier.show('Kindly provide a reason', 'Validation Response')

        await setUserProperty('acctDeletionData', {...user.acctDeletionData, reason})
        const response = await API.sendProfileDeactivationOtp()
        if (response) navigate(acctDeletionFlowType === 'alias' ? `/${institutionData.alias}/account-deletion/otp-validation` : '/account-deletion/otp-validation')
    }

    return (
        <>
            <AccountDeletionContainer>
                <CustomContainer>
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">Other Reasons</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <AppText align="center">Please tell us why you are deleting your account to help us serve you better.</AppText>
                        <Form onSubmit={handleProceed} topMargin='2'>
                            <FormGroup>
                                <label>Comment</label>
                                <textarea 
                                    name='reason'
                                    placeholder="Enter Comment"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2">
                                <Button 
                                    width='6.7' height='4' bgColor="#ffffff"
                                    borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                    onClick={() => navigate(acctDeletionFlowType === 'alias' ? `/${institutionData.alias}/account-deletion/reason` : '/account-deletion/reason')}
                                >
                                    Back
                                </Button>
                                <Button 
                                    width='8.7' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#ffffff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </CustomContainer>
            </AccountDeletionContainer>
        </>
    )
}

export default utility.routeData('other-reasons', 'Acct Deletion Other Reasons', <AcctDeleteOtherReasons/>)